<template>
  <div class="row m-1 topic-section">
    <div class="col-10 d-flex flex-wrap cards-container align-content-stretch justify-content-evenly">
      <TopicCardComponent v-for="card in topicCards"
                          :card-title="card.title"
                          :card-text="card.text"
                          :button-link="card.link"
                          :button-text="card.buttonText"
                          :icon="card.icon"
                          :is-enabled="card.isEnabled"
                          :embed-pdf="card.embedPdf"
                          :document-id="card.documentId"
                          :thumbnail-id="card.thumbnailId"></TopicCardComponent>
    </div>
    <div class="col-2 d-flex flex-column align-items-center justify-content-center">
      <h5 class="section-title">{{ sectionTitle }}</h5>
    </div>
  </div>
</template>

<script>
import TopicCardComponent from "@/views/TopicCardComponent.vue";

export default {
  components: {
    TopicCardComponent,
  },
  props: {
    sectionTitle: {
      type: String,
      required: true
    },
    topicCards: {
      type: Array,
      required: true
    }
  }
};
</script>